import React, { forwardRef, useEffect, useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import duckify from '../../utils/duckify'
import { activities, modals } from '../../ducks'
import { formatDateTime } from '../../utils';

const DateCustomInput = forwardRef(({ value, onClick, disabled }, ref) => {
  return (
    <a className={`ms-auto w-auto date ${!disabled ? "editable editable-click" : ""}`} onClick={onClick} ref={ref} >
      {value}
    </a>
  )
})

const Activity = ({ activityModel, accessList, activityList, updateUserActivity, markDirty, onDestroy }) => {
  const [model, setModel] = useState(activityModel)
  const [showDelete, setShowDelete] = useState(false)
  const [showVisibilityPopover, setShowVisibilityPopover] = useState(false)
  const [showActivityPopover, setShowActivityPopover] = useState(false)
  const [showNoteEdit, setShowNoteEdit] = useState(false)

  const [visibility, setVisibilty] = useState(model.access)
  const [activity, setActivity] = useState(model.activity_id)
  const [note, setNote] = useState(model.note)
  const [date, setDate] = useState(new Date(model.date))
  const [icon, setIcon] = useState('')
  const isEmail = model.type === 'email'

  useEffect(() => {
    if (model.type === 'email')
      setIcon('fa fa-envelope')
    else if (model.type === 'note')
      setIcon('fa fa-pencil-square-o')
    else
      setIcon('fa fa-share')
  }, [])

  const handleVisibiltyToggle = () => {
    setShowVisibilityPopover(!showVisibilityPopover)
  }
  const handleActivityToggle = () => {
    if (!isEmail) {
      setShowActivityPopover(!showActivityPopover)
    }
  }

  const updateAccess = event => {
    event.preventDefault()
    updateUserActivity({ id: model.id, access: visibility, date })
      .then(res => {
        setModel(res.result)
        setShowVisibilityPopover(false)
      })
  }
  const updateActivity = event => {
    event.preventDefault()
    updateUserActivity({ id: model.id, activity_id: activity, date })
      .then(res => {
        setModel(res.result)
        setShowActivityPopover(false)
      })
      .then(() => markDirty())
  }
  const updateNote = () => {
    updateUserActivity({ id: model.id, note, date })
      .then(res => {
        setModel(res.result)
        setShowNoteEdit(false)
      })
      .then(() => markDirty())
  }
  const updateDate = date => {
    updateUserActivity({ id: model.id, date })
      .then(() => setDate(date))
      .then(() => markDirty())
  }

  const handleVisibiltyChange = event => {
    setVisibilty(event.target.value)
  }
  const handleActivityChange = event => {
    setActivity(event.target.value)
  }
  const handleNoteChange = event => {
    setNote(event.target.value)
  }

  const visibilityPopover = (
    <Popover>
      <Popover.Body>
        <form onSubmit={updateAccess}>
          <select name='access' value={visibility} className='form-select form-select-sm w-auto' onChange={handleVisibiltyChange} >
            {accessList.map(elem => {
              const text = elem.charAt(0).toUpperCase() + elem.slice(1)
              return (<option key={elem} value={elem} >{text}</option>)
            })}
          </select>
          <button className="btn btn-primary mx-2 mt-2 col-auto"><i className="fa fa-check"></i></button>
          <a className="btn btn-light mt-2 close col-auto" onClick={handleVisibiltyToggle}><i className="fa fa-times"></i></a>
        </form>
      </Popover.Body>
    </Popover>
  )

  const activityPopover = (
    <Popover>
      <Popover.Body>
        <form onSubmit={updateActivity}>
          <select name='activity' value={activity} className='form-select form-select-sm w-auto' onChange={handleActivityChange} >
            {activityList.map(elem => {
              return (<option key={elem.value} value={elem.value} >{elem.text}</option>)
            })}
          </select>
          <button className="btn btn-primary mx-2 mt-2 col-auto"><i className="fa fa-check"></i></button>
          <a className="btn btn-light mt-2 close col-auto" onClick={handleActivityToggle}><i className="fa fa-times"></i></a>
        </form>
      </Popover.Body>
    </Popover>
  )

  return (
    <div
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}
    >
      <div className="row react note-details">
        <div className="note-details-title">
          {model.author_name} &nbsp;&nbsp; | &nbsp;&nbsp; Visible to {' '}
          <OverlayTrigger show={showVisibilityPopover} onHide={() => setShowVisibilityPopover(false)} placement='right' overlay={visibilityPopover}>
            <span className="visibility editable ediable-click" onClick={handleVisibiltyToggle}>
              {model.access.titleize()}
            </span>
          </OverlayTrigger>
        </div>
        <div className="note-details-date">
          <DatePicker
            name='date'
            value={date}
            selected={date}
            dateFormat={formatDateTime(date, 'fns_date') }
            popperPlacement='top-end'
            onChange={updateDate}
            disabled={isEmail}
            todayButton='Today'
            required
            customInput={<DateCustomInput />}
          />
        </div>
      </div>

      <div className={`content-container ${isEmail ? "expandable" : ""}`}>
        {showNoteEdit && !isEmail ?
          <form>
            <textarea name="content" value={note} onChange={handleNoteChange} className="form-control form-control-sm" rows="10" onBlur={updateNote} autoFocus ></textarea>
          </form> :
          <span className={`content ${!isEmail ? 'editable editable-click' : ''}`} onClick={() => setShowNoteEdit(true)} >
            {isEmail ?
              <div className='activity-inline-display' dangerouslySetInnerHTML={{ __html: model.note }} ></div> :
              <span className="activity-inline-display">{model.note}</span>
            }
          </span>
        }
      </div>
      <div
        className="row"
      >
        <div className={`left italic type-name ${!isEmail ? 'editable editable-click' : ''}`}>
          <OverlayTrigger show={showActivityPopover} onHide={() => setShowActivityPopover(false)} placement='right' overlay={activityPopover}>
            <span onClick={handleActivityToggle}>
              <i className={icon}></i>
              {model.activity_name}
            </span>
          </OverlayTrigger>
        </div>
        {!isEmail && showDelete && <i className="fa fa-trash-o red delete" onClick={() => onDestroy(model.id)}></i>}
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserActivity: (props) => dispatch(activities.actions.update(props)),
    onDestroy: (id) => dispatch(
      modals.actions.show('VerificationModal', {
        title: "Confirm Deletion",
        message: (<p>Are you sure you want to remove this activity?</p>),
        onConfirm: () => dispatch(activities.actions.remove({ id }))
          .then(() => dispatch(activities.actions.markDirty())),
      })
    ),
    markDirty: () => dispatch(activities.actions.markDirty()),
  }
}

export default duckify(() => ({}), () => { }, mapDispatchToProps)(Activity)
